import { create } from 'zustand'

/**
 * The how-to topic the current turn could not find a guide for, so the
 * answer can offer "Request this" (2026-10-02: users asking "what does the
 * red S mean?" got "No results found" and nothing to do next). Set by the
 * get_platform_guide executor on a zero-hit search, cleared when the user
 * sends the next message.
 */
interface DocGapState {
  topic: string | null
  record: (topic: string) => void
  clear: () => void
}

export const useDocGapStore = create<DocGapState>((set) => ({
  topic: null,
  record: (topic) => set({ topic: topic.trim().slice(0, 200) || null }),
  clear: () => set({ topic: null }),
}))
